import { useState } from 'react';
import Modal from './Modal';

export default function SettingsModal({
  isOpen,
  onClose,
  backgroundType,
  setBackgroundType,
  accessibility,
  setAccessibility,
}) {
  const [view, setView] = useState('main'); // 'main' | 'backgrounds' | 'accessibility'
  const [toastMessage, setToastMessage] = useState(null);

  const titles = {
    main:          'Settings',
    backgrounds:   'Backgrounds',
    accessibility: 'Accessibility',
  };

  const handleClose = () => {
    onClose();
    setView('main');
  };

  const handleDarkModeToggle = (e) => {
    e.preventDefault();
    const jokes = [
      "Error: User attempted to go blind.",
      "Light mode? In this economy?",
      "Access Denied: Why would you want this?",
      "I'm sorry Dave, I'm afraid I can't do that.",
      "😭",
      "Warning: Flashbang thwarted.",
    ];
    setToastMessage(jokes[Math.floor(Math.random() * jokes.length)]);
    setTimeout(() => setToastMessage(null), 3000);
  };

  const getActiveStyle = (type) => {
    const isActive = backgroundType === type;
    return {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0.75rem',
      borderRadius: '8px',
      border:     isActive ? '1px solid #6d6bf6' : '1px solid transparent',
      boxShadow:  isActive ? '-4px 0 15px rgba(59, 130, 246, 0.4), 4px 0 15px rgba(139, 92, 246, 0.4)' : 'none',
      background: isActive ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
    };
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={titles[view]}
      onBack={view !== 'main' ? () => setView('main') : undefined}
    >
      {/* Toast */}
      {toastMessage && (
        <div style={{
          background: 'rgba(239, 68, 68, 0.15)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          color: '#f87171',
          padding: '0.75rem',
          borderRadius: '8px',
          fontSize: '0.85rem',
          textAlign: 'center',
        }}>
          {toastMessage}
        </div>
      )}

      {/* ── Main View ─────────────────────────────────────────────── */}
      {view === 'main' && (
        <>
          {/* Dark Mode Joke Toggle */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.95rem', color: 'var(--text-primary)', fontWeight: '500' }}>Dark Mode</span>
            <label className="toggle-switch" style={{ margin: 0 }} onClick={handleDarkModeToggle}>
              <input type="checkbox" checked={true} readOnly />
              <span className="toggle-slider" />
            </label>
          </div>

          {/* Backgrounds Link */}
          <button
            onClick={() => setView('backgrounds')}
            className="dropdown-item"
            style={{
              background: 'var(--surface-color)',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              padding: '0.75rem',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              outline: 'none',
            }}
          >
            <span>Backgrounds</span>
            <span style={{ color: 'var(--text-secondary)' }}>→</span>
          </button>

          {/* Accessibility Link */}
          <button
            onClick={() => setView('accessibility')}
            className="dropdown-item"
            style={{
              background: 'var(--surface-color)',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              padding: '0.75rem',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              outline: 'none',
            }}
          >
            <span>Accessibility</span>
            <span style={{ color: 'var(--text-secondary)' }}>→</span>
          </button>
        </>
      )}

      {/* ── Backgrounds Sub-View ──────────────────────────────────── */}
      {view === 'backgrounds' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <button
            className={`dropdown-item ${backgroundType === 'none' ? 'active' : ''}`}
            onClick={() => setBackgroundType('none')}
            style={getActiveStyle('none')}
          >
            <span>None</span>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '2px' }}>
              Disable special backgrounds
            </span>
          </button>

          <button
            className={`dropdown-item ${backgroundType === 'arcade' ? 'active' : ''}`}
            onClick={() => setBackgroundType('arcade')}
            style={getActiveStyle('arcade')}
          >
            <span>Arcade</span>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '2px' }}>
              arcade floor.
            </span>
          </button>
        </div>
      )}

      {/* ── Accessibility Sub-View ────────────────────────────────── */}
      {view === 'accessibility' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.95rem', color: 'var(--text-primary)', fontWeight: '500' }}>
                Reduce Motion
              </span>
              <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '2px' }}>
                Disable animations and static background
              </span>
            </div>
            <label className="toggle-switch" style={{ margin: 0 }}>
              <input
                type="checkbox"
                checked={accessibility.reduceMotion}
                onChange={(e) => setAccessibility(prev => ({ ...prev, reduceMotion: e.target.checked }))}
              />
              <span className="toggle-slider" />
            </label>
          </div>
        </div>
      )}
    </Modal>
  );
}
